import React from 'react';
import { AccessErrorScreen, LoadingScreen, SignInScreen } from './GateScreens';
import { RegistrySessionContext } from './RegistrySession';
import RegistryUnavailable from './RegistryUnavailable';
import { useRegistryAccess } from './useRegistryAccess';

/**
 * Signs the admin in through Auth0 Universal Login (same tenant as the admin portal, so an
 * existing admin session signs straight in), then asks the backend whether the Registry is on
 * and this admin may use it. Only then are the children rendered.
 */
export default function RegistryGate({
  audience,
  children,
}: {
  audience?: string;
  children: React.ReactNode;
}) {
  const { signedOut, loading, loadError, retry, session, signIn, signOut } =
    useRegistryAccess(audience);

  if (signedOut) return <SignInScreen onSignIn={signIn} />;
  if (loadError) return <AccessErrorScreen message={loadError} onRetry={retry} />;
  if (loading || !session) return <LoadingScreen />;
  if (!session.me.available) return <RegistryUnavailable me={session.me} onSignOut={signOut} />;

  return (
    <RegistrySessionContext.Provider value={session}>{children}</RegistrySessionContext.Provider>
  );
}
